import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { featureFlagActions } from '../actions';

@Injectable()
export class WebAngularSharedDataAccessFeatureFlagApiEffects {
  private projectSpecificInitializationComplete = false;

  constructor(private featureFlagActions$: Actions) {}

  initializationComplete$: Observable<Action> = createEffect(() => this.featureFlagActions$.pipe(
    ofType(featureFlagActions.ActionTypes.SET_FLAGS),
    map(() => {
      this.projectSpecificInitializationComplete = true;

      return new featureFlagActions.InitalizationCompleteAction(
        this.projectSpecificInitializationComplete
      );
    })
  ));
}
